module.exports = __webpack_public_path__ + "img/NT-Before.b2ed3e78.png";